import { RequestsProvider } from 'Context';
import { FileUpload } from '../FileUpload';
import { CustomMetaTitle } from 'Components';
import { useDictionary } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { ISubCategory } from 'API/UniversalRequest/universalRequest';

interface IUploadFiles {
  subId: number;
  clearSubCategory: () => void;
  handleSuccess: () => void;
  resetRequest: () => void;
  titleLabel: string;
  onlineFormLink?: string;
  isDownload?: boolean;
  isOtp: boolean;
  subCategory?: ISubCategory;
}

export const UploadFiles = ({
  subId,
  clearSubCategory,
  handleSuccess,
  resetRequest,
  titleLabel,
  onlineFormLink,
  isDownload,
  isOtp,
  subCategory,
}: IUploadFiles) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.UniversalRequest);

  return (
    <>
      <CustomMetaTitle
        title={`${dictionary.title} ${dictionary.subject} ${titleLabel} - ${dictionary.metaTitleStepThree}`}
        disablePrefix
      />
      <RequestsProvider>
        <FileUpload
          subId={subId}
          goBack={clearSubCategory}
          handleSuccess={handleSuccess}
          resetRequest={resetRequest}
          titleLabel={titleLabel}
          onlineFormLink={onlineFormLink}
          isDownload={isDownload}
          isOtp={isOtp}
          subCategory={subCategory}
        />
      </RequestsProvider>
    </>
  );
};
